import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classnames from 'classnames/bind';

import styles from './android.scss';
let cx = classnames.bind(styles);
import * as amplitude from '@amplitude/analytics-browser';

const Android = ({ locale, translations }) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();

        if (email.length > 0) {
            amplitude.track('Android Waiting List Email Submitted');

            setEmail("");
        }
    }

    return (
        <main className={cx('android', 'flex', 'column')}>
            <div className={cx('title')}>{translations['ANDROID_TITLE']}</div>
            <p>
                {translations['ANDROID_DESCRIPTION_FIRST']}
                <br />
                {translations['ANDROID_DESCRIPTION_SECOND']}
                <br />
                {translations['ANDROID_DESCRIPTION_THIRD']}
            </p>
            <form className={cx('email', 'flex', 'row', 'align-items-center')} onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder={translations['EMAIL_PLACEHOLDER']}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <button type="submit" className={cx('submit')}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69 61"><path fillRule="evenodd" d="M36.323 3.888c-2.476 2.537-3.302 6.341-.826 9.301l6.604 8.877H6.193c-3.715 0-6.191 2.959-6.191 6.341v4.228c0 3.804 2.889 6.341 6.191 6.341h35.908l-6.604 8.877c-2.063 2.959-1.65 7.187 1.239 9.3l3.302 2.537c2.889 2.114 6.603 1.691 9.08-1.268l17.335-22.828c2.476-2.959 2.476-7.187 0-10.569L48.705 2.62c-2.064-2.959-6.191-3.382-9.08-1.268l-3.302 2.536z"></path></svg
                ></button>
            </form>
        </main>
    );
};

export default Android;
